import innovationField from './innovation-field'
import post from './post'
import innovationProject from './innovation-project'
import workspace from './workspace'

export default {
    tabs: {
        innovationField: 'Innovation field',
        post: 'Market analysis',
        workspace: 'Work space',
        innovationProject: 'Innovation project'
    },

    innovationField,
    post,
    innovationProject,
    workspace
}
